
import { defineComponent, getCurrentInstance, ref, computed } from 'vue'
export default defineComponent({
  props: {},
  setup(props, { emit }) {
    const { $root } = getCurrentInstance()!.proxy
    const menu = ref(false)

    const handleClick = () => {
      menu.value = false
    }
    const item1Html = computed(() => {
      return $root.$t('arrival_no_tooltip.item_1', {
        star: '「<span class="asterisk red--text">*</span>」'
      })
    })

    return {
      menu,
      handleClick,
      item1Html
    }
  }
})
